// @ts-nocheck
import { INotification, Notification } from '../Notification'
import { NotificationTypeEnum } from '../NotificationTypeEnum'
import { IVendorOrderPlacedSMSData } from './IVendorOrderPlacedSMSData'
import { NotificationClassificationEnum, User } from '../..'

export interface IVendorOrderPlacedSMS extends INotification {
  data: IVendorOrderPlacedSMSData
}

export class VendorOrderPlacedSMS extends Notification implements IVendorOrderPlacedSMS {
  constructor(public to: User, public data: IVendorOrderPlacedSMSData) {
    super(to, NotificationTypeEnum.VENDOR_ORDER_PLACED_SMS, NotificationClassificationEnum.SMS)
  }

  public get linkReplacement() {
    return [
      { name: 'minifiedViewLink', template: '{{{ magicLink }}}{{{ viewLink }}}' }
    ]
  }

  public get body() {
    return 'New order placed by {{ customer }} click this link to view the order: {{{ minifiedViewLink }}}'
  }
}
